import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SendOtpState {
  sendOtpPayload: any;
}

const initialState: SendOtpState = {
  sendOtpPayload: "",
};

const sendOtpSlice = createSlice({
  name: "sendOtpPayload",
  initialState,
  reducers: {
    setSendOtpData: (state, action: PayloadAction<any>) => {
      state.sendOtpPayload = action.payload;
    },
  },
});

export const { setSendOtpData } = sendOtpSlice.actions;
export default sendOtpSlice.reducer;
